import PharmacistBlock from './PharmacistBlock';

export default PharmacistBlock;
